// @core/api/endpoints/calendar/update_calendar_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CalendarPolicyResponse,
  UpdateCalendarPolicyRequest,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Update calendar policy
 * Updates an existing calendar policy.
 */
export async function UpdateCalendarPolicy(
  policy_id: string,
  data: UpdateCalendarPolicyRequest,
  options?: RequestOptions
): Promise<CalendarPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/calendar-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.put<CalendarPolicyResponse>(requestPath, data, requestOptions);
}
